// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/images/projectdetails/bg_first.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.details_main_section__rivBK {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-size: cover;
  height: auto;
  max-width: 100%;
  margin: 0;
  padding: 0;

  .details_heroSection__\\+D7e3 {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    margin: 5rem 0;
  }
}

.details_section__GuvOR {
  width: 96%;
  margin: 4rem auto;

  & img {
    margin-top: 1rem;
    max-width: 100%;
    height: auto;
  }
}

.details_left_section__cbc\\+a {
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  gap: 0.8rem;

  & p {
    font-family: Inter;
    font-weight: 500;
    font-size: 0.9rem;
    line-height: 16.94px;
  }

  & img {
    max-width: 100%;
    height: auto;
  }
}

.details_right_section__ICa8V {
  height: 100%;

  & img {
    max-width: 100%;
    height: auto;
  }
}

.details_benfit__WYipb {
  margin: 1.2rem 0;
  display: flex;
  justify-content: flex-start;
  flex-direction: column;

  .details_info__jHURx {
    display: flex;
    flex-direction: column;
    gap: 1.2rem;
  }

  .details_box__FT9fz {
    background: #fcfcfc;
    width: 100%;
    height: auto;
    gap: 10px;
    border: 1px solid #eeeeee;
    border-radius: 8px;
    padding: 22px;

    & h6 {
      font-family: Inter;
      font-weight: 600;
      font-size: 0.9rem;
    }

    & p {
      margin: 0;
      color: #a4a4a4;
      font-family: Inter;
      font-weight: 400;
      font-size: 0.9rem;
    }
  }
}

/* --------media-queries---------- */

@media screen and (max-width: 568px) {
  br {
    display: none;
  }

  .details_main_section__rivBK {
    height: auto;

    .details_heroSection__\\+D7e3 {
      margin: 2rem 0;
    }
  }

  .details_left_section__cbc\\+a img {
    margin-bottom: 1.2rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Pages/Details/details.module.css"],"names":[],"mappings":"AAAA;EACE,yDAAmE;EACnE,4BAA4B;EAC5B,sBAAsB;EACtB,YAAY;EACZ,eAAe;EACf,SAAS;EACT,UAAU;;EAEV;IACE,aAAa;IACb,uBAAuB;IACvB,sBAAsB;IACtB,mBAAmB;IACnB,cAAc;EAChB;AACF;;AAEA;EACE,UAAU;EACV,iBAAiB;;EAEjB;IACE,gBAAgB;IAChB,eAAe;IACf,YAAY;EACd;AACF;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,sBAAsB;EACtB,WAAW;;EAEX;IACE,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,eAAe;IACf,YAAY;EACd;AACF;;AAEA;EACE,YAAY;;EAEZ;IACE,eAAe;IACf,YAAY;EACd;AACF;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,2BAA2B;EAC3B,sBAAsB;;EAEtB;IACE,aAAa;IACb,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,SAAS;IACT,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;;IAEb;MACE,kBAAkB;MAClB,gBAAgB;MAChB,iBAAiB;IACnB;;IAEA;MACE,SAAS;MACT,cAAc;MACd,kBAAkB;MAClB,gBAAgB;MAChB,iBAAiB;IACnB;EACF;AACF;;AAEA,oCAAoC;;AAEpC;EACE;IACE,aAAa;EACf;;EAEA;IACE,YAAY;;IAEZ;MACE,cAAc;IAChB;EACF;;EAEA;IACE,qBAAqB;EACvB;AACF","sourcesContent":[".main_section {\n  background-image: url(\"/public/images/projectdetails/bg_first.png\");\n  background-repeat: no-repeat;\n  background-size: cover;\n  height: auto;\n  max-width: 100%;\n  margin: 0;\n  padding: 0;\n\n  .heroSection {\n    display: flex;\n    justify-content: center;\n    flex-direction: column;\n    align-items: center;\n    margin: 5rem 0;\n  }\n}\n\n.section {\n  width: 96%;\n  margin: 4rem auto;\n\n  & img {\n    margin-top: 1rem;\n    max-width: 100%;\n    height: auto;\n  }\n}\n\n.left_section {\n  display: flex;\n  justify-content: flex-start;\n  flex-direction: column;\n  gap: 0.8rem;\n\n  & p {\n    font-family: Inter;\n    font-weight: 500;\n    font-size: 0.9rem;\n    line-height: 16.94px;\n  }\n\n  & img {\n    max-width: 100%;\n    height: auto;\n  }\n}\n\n.right_section {\n  height: 100%;\n\n  & img {\n    max-width: 100%;\n    height: auto;\n  }\n}\n\n.benfit {\n  margin: 1.2rem 0;\n  display: flex;\n  justify-content: flex-start;\n  flex-direction: column;\n\n  .info {\n    display: flex;\n    flex-direction: column;\n    gap: 1.2rem;\n  }\n\n  .box {\n    background: #fcfcfc;\n    width: 100%;\n    height: auto;\n    gap: 10px;\n    border: 1px solid #eeeeee;\n    border-radius: 8px;\n    padding: 22px;\n\n    & h6 {\n      font-family: Inter;\n      font-weight: 600;\n      font-size: 0.9rem;\n    }\n\n    & p {\n      margin: 0;\n      color: #a4a4a4;\n      font-family: Inter;\n      font-weight: 400;\n      font-size: 0.9rem;\n    }\n  }\n}\n\n/* --------media-queries---------- */\n\n@media screen and (max-width: 568px) {\n  br {\n    display: none;\n  }\n\n  .main_section {\n    height: auto;\n\n    .heroSection {\n      margin: 2rem 0;\n    }\n  }\n\n  .left_section img {\n    margin-bottom: 1.2rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main_section": `details_main_section__rivBK`,
	"heroSection": `details_heroSection__+D7e3`,
	"section": `details_section__GuvOR`,
	"left_section": `details_left_section__cbc+a`,
	"right_section": `details_right_section__ICa8V`,
	"benfit": `details_benfit__WYipb`,
	"info": `details_info__jHURx`,
	"box": `details_box__FT9fz`
};
export default ___CSS_LOADER_EXPORT___;
